import { httpClient } from '../http/httpClient'

export interface CreateLeadPayload {
  name: string
  cpf: string
  phone: string
  birthDate: string
  linkName: string
}

export interface CreateLeadResponse {
  _id: string
  name: string
  cpf: string
  phone: string
  birthDate: string
  linkName: string
  contacted: boolean
  createdAt: string
  updatedAt: string
  __v: number
}

export async function createLead(payload: CreateLeadPayload) {
  const { data } = await httpClient
    .post<CreateLeadResponse>('/lead', payload)
    .catch((error) => {
      throw error.response.data || error
    })
  return data
}
